import './bootstrap';

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

window.Alpine = Alpine;

Alpine.plugin(collapse);

document.addEventListener('DOMContentLoaded', () => {
    document.dispatchEvent(new CustomEvent('alpine:init'));
    Alpine.start();
});
